import { FC } from 'react'
import { Grid, IconButton, Stack, Typography} from '@mui/material'
import { Container } from '@mui/system';
import { ArrowBackIos, ArrowForwardIos, Padding } from '@mui/icons-material'
import { Moment } from 'moment'
// import Dropdown from 'component/shared/dropdown/Dropdown'
import { useSelector } from 'react-redux'

interface Props {
  changeMonth: (action: string) => void
  date: Moment
  currentMonth: number
  setCurrentMonth: (number: number) => void
  currentYear: number
  setCurrentYear: (number: number) => void
}

const Controls: FC<Props> = ({ changeMonth, date, currentMonth,setCurrentMonth,currentYear,setCurrentYear}) => {
  
  const locale = useSelector(({theme})=>theme.locale);

  const getWeekDays = () => locale=='en'?[
    'MON',
    'TUE',
    'WED',
    'THU',
    'FRI',
    'SAT',
    'SUN',
  ]
  :
  [
    'الاثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
    'الأحد',
  ]
  function getMonth(n:any){
    const months=locale=='en'?
    ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November","December"]
    :
    ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    return months[(n-1)%12];
}

  const weekDays = getWeekDays()
  return (
    <div>
    <Stack
      sx={{backgroundColor:'#0a0a4b'}}
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      padding='0.5em 1em'
    >
      <Stack direction='row'>
        <IconButton
          aria-label='previous month'
          onClick={() => {changeMonth('subtract'); {if(currentMonth>1)setCurrentMonth(currentMonth-1);else {setCurrentMonth(12);setCurrentYear(currentYear-1);}};}}
          size='small'
          //color='primary'
          sx={{color:'#FFF'}}
        >
          {locale=='en'?<ArrowBackIos />:<ArrowForwardIos />}
        </IconButton>
        
      </Stack>
      <Container maxWidth='xs'>
        <center>
        <h5 style={{color:'#FFF'}}>{getMonth(currentMonth)+" "+date.year()}</h5>
        </center>
        {/* <Dropdown item={[date.toString(),moment().subtract(1, 'months').format('MMMM, YYYY'),moment().subtract(2, 'months').format('MMMM, YYYY'),moment().subtract(3, 'months').format('MMMM, YYYY'),moment().subtract(4, 'months').format('MMMM, YYYY')]}/> */}
      </Container>
      <IconButton
          aria-label='next month'
          onClick={() =>{ changeMonth('add'); {if(currentMonth<12)setCurrentMonth(currentMonth+1);else {setCurrentMonth(1);setCurrentYear(currentYear+1);}};}}
          size='small'
          //color='primary'
          sx={{color:'#FFF'}}
        >
          {locale=='en'?<ArrowForwardIos />:<ArrowBackIos />}
        </IconButton>
  </Stack>



  <Stack
      sx={{backgroundColor:'#0090FF'}}
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      paddingTop={3}
      paddingBottom={3}
      //padding='0.5em 1em'
      borderBottom='1px solid rgba(0, 145, 255, 1)'
    >
      {weekDays.map((item, i) =>
        <Grid key={i} width={`${100 / 7}%`} sx={{textAlign: 'center'}}>
          <Typography sx={{color:'#FFFFFF',fontSize:'14px', fontFamily: "'Tajawal'"}}>{item}</Typography>
        </Grid>
      )}
  </Stack>
  </div>
    
  )
}

export default Controls
